import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Featureveteran() {
  return (
    <section className="feature_veteran text_veteran">
      <Container>
        <Row>
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>Key Features</h2>
            <h2 style={{ color: "#000" }}>
              Social Communities, Events & Much More
            </h2>
            <p>
              The Veteran App isn’t just about careers and opportunities. There
              is a lot more to it for Veterans who really want to turn their
              lives around. Being a Veteran can be hard, especially in the
              initial years when you come back from service and that’s why we
              have added specialized features to help Veterans find the best
              ways to socialize and forge new relationships.
            </p>
            <p>
              Join The Veteran App Now To Access This Growing,Highly Successful
              Community That’s Doing Everything To Serve The People That Risk
              Their Lives To Protect Us & Our Homeland.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1 text-center"
          >
            <div className="banner_img">
              <StaticImage
                src="../../../images/case-studies/veteran-app/feature_img.webp"
                alt="TekRevol"
                className=""
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={685}
                height={591}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <StaticImage
              src="../../../images/case-studies/veteran-app/flag_img.webp"
              alt="TekRevol"
              className=""
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={1046}
              height={473}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Featureveteran;
